var _rect, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 32,
    height: 36,
    rx: 2.5,
    stroke: "#535353",
    strokeWidth: 2.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 36,
    y2: 14,
    stroke: "#535353",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 36,
    y2: 21,
    stroke: "#535353",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 28,
    x2: 30,
    y2: 28,
    stroke: "#535353",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueDescription);
export default __webpack_public_path__ + "static/media/issue_description.40602f875505ee22c9a9eda1c49e69c4.svg";
export { ForwardRef as ReactComponent };